module.exports = __webpack_public_path__ + "img/jenis_pengiriman.67060da1.svg";